import { Text } from 'app/design/primitives/text';
import type { Listing } from 'app/types/listing';
import { ListingType } from 'app/types/listing';
import { FeatureType } from 'app/types/recommender';
import { Strategies } from '../../all-listings/components/recommended-listings';
import { DesktopRecommendationSection } from '../../all-listings/components/recommended-listings.large';
import { landingPageLargeStyles as styles } from '../large-styles';
import type { useDesktopLandingData } from '../use-desktop-landing-data';

export function MixedRecommendationsDiscoverySection({ data }: { data: ReturnType<typeof useDesktopLandingData> }) {
  const { mixedRecommendations, shouldShowRecommendationSection } = data;
  if (!shouldShowRecommendationSection(mixedRecommendations)) return null;
  return (
    <DesktopRecommendationSection
      strategyProps={{
        strategy: Strategies.UseMixedRecommendations,
        recommendationType: ListingType.offer,
        similarityType: FeatureType.CONTENT,
      }}
      recommendationState={mixedRecommendations}
      recommendations={mixedRecommendations.recommendations as Listing[] | undefined}
      titleSuffix={<Text style={styles.headerIcon}>✨</Text>}
    />
  );
}
